export const watch = {
  currentHoaId(hoaID) {
    console.debug(hoaID)
    this.refresh()
  },

  toggleUpdater() {
    console.debug('in watch for toggleUpdater...' + this.toggleUpdater)
    if (this.toggleUpdater == false) {
      console.debug('after reload...')
      if (this.Modal && this.Modal != undefined) {
        this.Modal.$emit('update:toggle', (this.toggle = false))
        this.Modal.$emit('update:forceClose', (this.toggle = false))
      }
    }
  }
}
